import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import MultilineText from './MultilineText';
import { printtimeat } from '../function/printtimeat';
import { auth, db } from '../settings/firebase';
import BookmarkArea from './BookmarkArea';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "0",
    margin: "2px 2px 2px 2px",
    minWidth: "150px",
    width: "45vw",
    maxWidth: "250px",
    height: "305px",
    borderRadius: "10px",
    background: "rgba(255, 255, 255, 0.94)",
    /* dropshadow_color */
    boxShadow: "0px 2px 3px rgba(124, 121, 107, 0.25)",
    overflow: "hidden",
  },
  // アイキャッチ画像エリア
  // 推薦記事表示領域
  suggestedView: {
    width: "100%",
    textDecoration: "none",
  },
  image: {
    width: "100%",
    height: "160px",
    overflow: "hidden",
  },
  img: {
    margin: 'auto',
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: "cover",
  },
  // ボディテキストエリア
  postbodytextarea: {
    display: "flex",
    flexDirection: "column",
    padding: "5px",
    justifyContent: "flex-start",
    textAlign: "left",
  },
  // アバター表示
  postbodyavatar: {
    display: "flex",
  },
  postbodyavatarlabel: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "5px",
    marginTop: "0",
  },
  postbodyname: {
    textDecoration: "none",
    fontSize: "12px",
    marginBottom: "0",
  },
  postbodydate: {
    marginTop: ".4em",
    fontSize: "9px",
    color: theme.palette.text.secondary,
    marginBottom: "0",
  },
  // ページタイトル
  suggestTitle: {
    width: "100%",
    marginTop: "7px",
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize:"11px",
    textAlign: "left",
    color: theme.palette.text.primary,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  // 推薦理由
  suggestComment: {
    display: "flex",
    cursor: "pointer",
    width: "100%",
    height: "3em",
    marginTop: ".5em",
    // フォント
    fontFamily: "Roboto",
    fontStyle: "normal",
    fontWeight: "bold",
    fontSize: "9px",
    textAlign: "justify",
    letterSpacing: "0.03em",
    color: theme.palette.text.secondary,
  },
  suggestCommentMultiline: {
    display: "-webkit-box",
    overflow: "hidden",
    fontSize: "9px",
    "-webkit-line-clamp": "2",
    "-webkit-box-orient": "vertical",
  },
  postbodybaricon: {
    height: "30px",
    width: "30px",
    marginRight: "3px",
  },
}));

export default function PostBody(props) {
  const classes = useStyles();
  // const [ mylike, setmylike ] = useState(false);
  const { data } = props;
  const [nowuid, setnowuid] = useState("");
  const [ mylike, setmylike ] = useState(false);
  const [ myselect, setmyselect ] = useState(false);
  const [ datastar, setdatastar ] = useState(data.star);

  // 渡されたデータの取得
  // console.log(data)
  const link = "/" + data.displayid + "/p/" + data.docId;
  // console.log(link)

  auth.onAuthStateChanged(user => {
    if (user) {
      setnowuid(user.uid);
      db.collection("users").doc(user.uid).onSnapshot(doc => {
        if(doc.exists) {
          doc.data().favorite.forEach(fav => {
            if (fav.pid === data.docId) {
              setmyselect(true);
            }
          })
        }
      })
    }
  })

  const changeStateMylike = (bool) => {
    setmylike(bool);
  }
  const changeStateMyselect = (bool, newstar) => {
    setmyselect(bool);
    setdatastar(newstar);
  }
  
  return (
    <Paper className={classes.paper}>
      <Grid className={classes.suggestedView} component={Link} to={link}>
        <Grid item>
          <ButtonBase className={classes.image}>
            <img className={classes.img} alt="complex" src={data.thumbnail} />
          </ButtonBase>
        </Grid>
        <div className={classes.postbodytextarea}>
          <div className={classes.postbodyavatar}>
            <Avatar alt={data.displayid} src={data.avatarUrl} component={Link} to={"/" + data.displayid} />
            <div className={classes.postbodyavatarlabel}>
              <span>
                <Link className={classes.postbodyname} style={{color: "#333333"}} to={"/" + data.displayid}>{data.username}</Link>
              </span>
              <span>
                {data.createdAt?
                  <p className={classes.postbodydate}>{printtimeat(data.createdAt)}投稿</p>
                : null }
              </span>
            </div>
          </div>
          <Typography gutterBottom variant="subtitle1" className={classes.suggestTitle}>
            {data.title}
          </Typography>
          <Typography variant="body2" className={classes.suggestComment}>
            <MultilineText className={classes.suggestCommentMultiline}>{data.comment}</MultilineText>
          </Typography>
        </div>
      </Grid>
      <Grid style={{display: "flex", justifyContent: "flex-end", marginRight: "5px", alignItems: "center"}}>
        <BookmarkArea
          data={data} nowuid={nowuid}
          changeStateMylike={changeStateMylike} changeStateMyselect={changeStateMyselect}
          mylike={mylike} myselect={myselect} star={datastar}
          className={classes.postbodybaricon} iconSize={"26px"}
        />
      </Grid>
    </Paper>
  );
}